<div
  *ngIf="!isLoading && sortParams"
  (click)="toggleSortingOrder()"
  role="button"
  data-test-id="sorting-icon"
  class="sort-icon-name hide-element d-flex"
>
  <label class="header-font cursor-pointer" data-test-id="header-title-sorting">
    {{ title | translate }}
  </label>
  <img
    *ngIf="!isLoading && sortParams.preparedSortCategory === sortParams.currentSortCategory"
    class="sort-icon"
    [src]="sortParams.ascending ? ASCENDING_ICON : DESCENDING_ICON"
    alt="Sorting icon"
    data-test-id="sorting-image"
  />&nbsp;
</div>

<div *ngIf="!isLoading && !sortParams" class="d-flex">
  <label class="header-font mb-2" data-test-id="header-title-sorting">
    {{ title | translate }}
  </label>
</div>
